export const formatarTelefone = (valor: string): string => {
  const digitos = valor.replace(/\D/g, "");

  if (digitos.length > 10) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7, 11)}`;
  }
  if (digitos.length > 5) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
  }
  if (digitos.length > 2) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`;
  }
  if (digitos.length > 0) {
    return `(${digitos}`;
  }
  return "";
};
